import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface HotelBenchmarkInsightDropdownsTriggersTriggerReferencePeriodSignature {
  Args: {
    isOpen?: boolean;
    label: unknown;
    selected: unknown;
    toggleDropdown: unknown;
  };
}

const HotelBenchmarkInsightDropdownsTriggersTriggerReferencePeriod = <template>
  {{! template-lint-disable require-presentational-children }}
  <div
    class="select-wrapper left-column subnav-trigger picker month-selection-trigger prism-dropdown-trigger
      {{if @isOpen 'open'}}
      {{if @label 'has-label'}}"
    data-event-id="datepicker-toggle-dropdown"
    data-test-id="datepicker-toggle-dropdown"
    role="button"
    {{! @glint-expect-error }}
    {{on "click" @toggleDropdown}}
  >
    <div class="trigger__content gap-100">
      {{! @glint-expect-error }}
      {{@selected}}

      <PrismIcon
        @name={{if @isOpen "chevron-up" "chevron-down"}}
        @size="small"
      />
    </div>
  </div>
</template> satisfies TOC<HotelBenchmarkInsightDropdownsTriggersTriggerReferencePeriodSignature>;

export default HotelBenchmarkInsightDropdownsTriggersTriggerReferencePeriod;
